import React from 'react';
import './App.css';
import DoctorsTable from './Components/DoctorsTable';

function App() {
  return (
    <DoctorsTable />
  );
}

export default App;
